import { render } from "./ViewEmployeeAttendanceSummary.vue?vue&type=template&id=683f2a1c&scoped=true"
import script from "./ViewEmployeeAttendanceSummary.vue?vue&type=script&lang=js"
export * from "./ViewEmployeeAttendanceSummary.vue?vue&type=script&lang=js"

import "./ViewEmployeeAttendanceSummary.vue?vue&type=style&index=0&id=683f2a1c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683f2a1c"]])

export default __exports__